
import { Center, Entity, Device, ServicePoint } from "@/entities";
import { i18n } from "@/i18n";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import PIcon from "@/common/components/look/PIcon/PIcon.vue";
import { PButton, PModal } from "@/common/components";
import ServicePointForm from "@/components/servicePoints/servicePoint-form/ServicePointForm.vue";
import { SERVICEPOINTTYPE_CASHTODAY } from "@/services";

@Component({
  name: "servicepoint-modal",
  i18n,
  components: {
    PModal,
    PIcon,
    PButton,
    ServicePointForm,
  },
})
export class ServicePointModal extends Vue {
  @Prop({ required: true }) value!: boolean;
  @Watch("value", { immediate: true, deep: true })
  onChangeValue(): void {
    this.showModal = this.value;
  }
  @Prop({ required: true }) center!: Center;
  @Prop({ required: true }) entity!: Entity;
  @Prop({ required: true }) device!: Device;
  @Prop({ required: true }) servicePoint!: ServicePoint;
  @Prop({ required: false, default: true }) isModify!: boolean;
  @Prop({ required: false, default: "button.btn_save" }) textActionName!: string;
  showModal = false;
  isCashToday = SERVICEPOINTTYPE_CASHTODAY;

  closeModal(): void {
    this.showModal = false;
    this.$emit("input", false);
  }

  get titleModal(): string {
    return this.isModify
      ? this.$t("spPage.modal.modal_edit_title") + this.servicePoint.name
      : (this.$t("spPage.modal.modal_create_title") as string);
  }

  async saveServicePoint(servicePoint: ServicePoint, update: boolean, _action: string): Promise<void> {
    try {
      if (update) {
        await this.$services.servicepoint.updateServicePointV3(servicePoint);
        await Vue.swal({
          icon: "success",
          title: this.$i18n.t("spPage.modal.success"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("refresh", {created: false});
      } else {
        const payload: ServicePoint = {
          ...servicePoint,
          device: this.device,
          center: this.center,
          entity: this.entity,
        };

        await this.$services.servicepoint.createServicePointV3(payload);
        await Vue.swal({
          icon: "success",
          title: this.$i18n.t("spPage.modal.success_create"),
          showConfirmButton: false,
          timer: 2000,
        });
        this.$emit("refresh", { created: false });
      }
    } finally {
      this.closeModal();
    }
  }
}
export default ServicePointModal;
